import { Button, Col, Drawer, Row, Text } from '@/components';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

type Props = {
  onSubmit: () => void;
  onClose: () => void;
} & (
  | {
      type: 'lock' | 'unlock';
      open: true;
    }
  | {
      type: undefined;
      open: false;
    }
);

export const BulkLockDrawer: FC<Props> = ({
  type,
  open,
  onSubmit,
  onClose,
}) => {
  const { t } = useTranslation();
  return (
    <Drawer open={open} onClose={onClose}>
      <Row gutter={[0, 16]}>
        <Col span={24}>
          {type === 'lock' ? (
            <Text text={t('bulk-lock-confirm-message')} />
          ) : (
            <Text text={t('bulk-unlock-confirm-message')} />
          )}
        </Col>
        <Col span={24}>
          <Button onClick={onSubmit}>{t('execute')}</Button>
        </Col>
      </Row>
    </Drawer>
  );
};
